import * as yup from 'yup'

const PettyCashRequestSchema = yup.object().shape({
    PMState: yup.string().required('This Field is required').trim(),
    //pettyCashType: yup.string().required('This Field is required').trim(),
    prodDesc: yup.string().required('This Field is required').trim(),
    //transactionDate : yup.string().required('This Field is required').trim(),
    //documentType : yup.string().required('This Field is required').trim()
})

const pettyCashExpenseDetails = {
    pettyCashCategoryId : "",
    prodDesc : "",
    unit : "",
    HSNCode : "",
    TDS : "",
    unitPrice : "",
    quantity : "",
    IGST : 0,
    CGST : 0,
    SGST : 0,
    
}

const PettyCashExpenseSchema = yup.array().of(
    yup.object().shape({
        pettyCashCategoryId: yup.string().required('This Field is required').trim(),
        prodDesc: yup.string().required('This Field is required').trim(),
        unit: yup.number().transform(value => (value ? parseInt(value) : null)).nullable().required('This Field is required'),
        HSNCode: yup.number().transform(value => (value ? parseInt(value) : null)).nullable().required('This Field is required'),
        TDS: yup.string().required('This Field is required').trim(),
        unitPrice: yup.number().transform(value => (value ? parseInt(value) : null)).nullable().required('This Field is required'),
        quantity: yup.number().transform(value => (value ? parseInt(value) : null)).nullable().required('This Field is required'),
        docNo: yup
            .number()
            .nullable()
            .test('validate-docType', 'Invalid DocNo format', function (value) {
                const { isDocNoMandatory, docType } = this.parent

                if (isDocNoMandatory && !value) {
                    return this.createError({ message: 'This field is required' })
                }

                if (!value || !docType) return true

                const docNoStr = String(value)

                const validationRules = {
                    reqno: { prefix: "11", length: 15 },
                    buyerpono: { prefix: "14", length: 15 },
                    sellerpono: { prefix: "15", length: 15 },
                    sellerpino: { prefix: "16", length: 15 },
                    vpno: { prefix: "19", length: 15 },
                    buyerinvoiceno: { prefix: "20", minLength: 10, length: null }
                }

                const rule = validationRules[docType?.toLowerCase()]
                if (!rule) return this.createError({ message: `Invalid docType. Please contact Tech Team!` })

                if (!docNoStr.startsWith(rule.prefix)) {
                    return this.createError({ message: `${docType} must start with ${rule.prefix}` })
                }

                if (docType.toLowerCase() === "buyerinvoiceno" && docNoStr.length < rule.minLength) {
                    return this.createError({ message: `DocNo length must be at least ${rule.minLength} digits` })
                }

                if (rule.length && docNoStr.length !== rule.length) {
                    return this.createError({ message: `DocNo length must be exactly ${rule.length} digits` })
                }

                return true
            })
    })
)

const PettyCashTransactionSchema = yup.object().shape({
    PMState: yup.string().required('This Field is required').trim(),
    pettyCashType : yup.string().required('This Field is required').trim(),
    //receivedBy: yup.string().required('This Field is required').trim(),
    transactionDate : yup.string().required('This Field is required').trim(),
    documentType : yup.string().required('This Field is required').trim(),
    //documentPath : yup.string().required('This Field is required').trim(),
    
})


const pettyCashRequestDetails = {
    PMState : "",
    amount : "",
    prodDesc : ""
}



const pettyCashTransactionDetails = {
    PMState : "",
    pettyCashType : "EXPENSE-CASH",
    receivedBy : "",
    transactionDate : "",
    documentType : "VOUCHER",
    documentPath: []
}

export { PettyCashRequestSchema, pettyCashRequestDetails, PettyCashExpenseSchema, pettyCashExpenseDetails, PettyCashTransactionSchema, pettyCashTransactionDetails}